import React from 'react';
import { MenuList as ChakraMenuList, MenuListProps as ChakraMenuListProps } from '@chakra-ui/react';

export function MenuList(props: ChakraMenuListProps) {
  return <ChakraMenuList {...props} />;
}
